<template>
  <div class="wrapper">
    <div class="card card-custom shadow-none">
      <div
        class="card-body d-flex align-items-center justify-content-between px-0"
      >
        <div class="input-icon">
          <input
            type="text"
            class="form-control rounded-pill"
            placeholder="Search..."
            :disabled="disabled"
            v-model="term"
            @input="search"
          />

          <span class="mt-1 mx-2">
            <i class="material-icons text-muted">search</i>
          </span>
        </div>

        <b-button
          v-if="$permissions.businesses.create"
          variant="dark"
          class="btn-pill font-weight-bolder"
          :disabled="disabled"
          @click="create"
          >New Company</b-button
        >
      </div>
    </div>

    <div class="card card-custom shadow-none">
      <div class="card-body p-0">
        <div class="blockui shadow-sm zindex-1" v-if="querying">
          <span class="btn spinner spinner-lg spinner-dark spinner-left"
            >Loading...</span
          >
        </div>

        <div
          class="d-flex align-items-center justify-content-center"
          v-if="empty"
        >
          <span v-if="querying">...</span>
          <span v-else-if="error">{{ error }}</span>
          <span v-else>No results found.</span>
        </div>

        <div v-for="(object, i) in objects" :key="i">
          <div @click="moveToCompany(object.id)" class="card card-custom bg-white border mb-4" :id="`card_${i}`">
            <div class="card-body row p-4">
              <div class="col-10 d-flex align-items-center">
                <div class="d-flex">
                  <div class="symbol symbol-65 symbol-light border rounded">
                    <img alt="image" :src="baseURL + object.image['128']" v-if="object.image" />
                    
                    <span class="symbol-label" v-else />
                  </div>
                </div>

                <span class="font-size-lg font-weight-bolder ml-3">{{
                  object.name
                }}</span>
              </div>

              <div
                v-if="$permissions.businesses.delete"
                class="col-2 d-flex justify-content-center justify-content-lg-end align-items-center"
              >
                <button
                  class="btn btn-icon btn-circle btn-hover-dark mr-4"
                  title="Preview"
                  :disabled="disabled"
                  @click.stop="view(object)"
                  v-b-tooltip.hover
                >
                  <i class="material-icons icon-lg">visibility</i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <paginator :disabled="disabled" :size="page_size" :total="total" />

        <form-modal ref="form_modal" />
        <c-details ref="details-modal" @preview="previewNewsletter()" />
        <newsletter ref="newsletter-modal" />
      </div>
    </div>
  </div>
</template>

<script>
import Paginator from "@/components/paginator.vue";
import CompaniesService from "@/services/companies.service";

import FormModal from "./components/form";
import CDetails from "./components/details";
import Newsletter from "./components/newsletter.vue";

export default {
  name: "Companies",
  components: {
    Paginator,
    FormModal,
    CDetails,
    Newsletter
  },
  methods: {
    previewNewsletter(){
      this.$refs["newsletter-modal"].open(this.currentBusiness.id);
    },
    moveToCompany(id) {
      this.$router.push({name: 'Company', params:{business_id: id}})
    },
    search() {
      clearTimeout(this.debounce);

      this.debounce = setTimeout(() => {
        let params = {};

        if (this.term) params.search = this.term;

        this.query(params);
      }, 500);
    },
    query(params = {}) {
      params["page"] = this.$route.query.page || 1;
      params["page_size"] = this.page_size;

      if (this.term) params.search = this.term;

      this.error = null;
      this.querying = true;

      CompaniesService.query(params)
        .then(({ count, data }) => {
          this.total = count;
          this.objects = data.map((item) => {
            return item;
          });
        })
        .catch(({ message }) => {
          this.error = "There was an error loading companies.";
        })
        .finally(() => {
          this.querying = false;
        });
    },
    view(business) {
      this.currentBusiness = business;
      this.$refs["details-modal"].open(business);
    },
    create() {
      this.$refs.form_modal.show();
    },
  },
  watch: {
    "$route.query.page"(value) {
      this.query();
    },
  },
  computed: {
    empty() {
      return this.objects.length === 0;
    },
    disabled() {
      return this.querying || this.deleting;
    },
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_API_URL,
      debounce: null,
      term: null,
      error: null,
      querying: false,
      deleting: false,
      total: 0,
      page_size: 20,
      objects: [],
      currentBusiness:{}
    };
  },
  mounted() {
    if (!this.$permissions.businesses.read) this.$router.push({ name: "403" });
    this.query();
  },
};
</script>

<style scoped>
@import "./index.scss"
</style>
